module.exports = __webpack_public_path__ + "static/img/dark.ccbb6cbd.svg";